<mat-toolbar>

    <div fxLayout="row" fxLayoutAlign="end center" fxFlex>

        <button mat-raised-button color="primary" (click)="showVersion()">
            <mat-icon>info</mat-icon>
            Sobre FTAGo!
        </button>
        
    </div>

</mat-toolbar>